import DefaultLayout from './defaultLayout';

export default DefaultLayout;
